import { Row, Col, Card, Button } from "antd";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import Api, { KY } from "src/Api";
import { Table, Tag } from "antd";
import { useMemo } from "react";

function Tables() {
  const history = useHistory();
  const { data } = useQuery(
    "drivers-lists",
    async () => await KY.get(Api.drivers.list).json()
  );
  const columns = useMemo(
    () => [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        // render: (text) => <a>{text}</a>,
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone",
      },
      {
        title: "Image",
        dataIndex: "Image",
        key: "Image",
      },
      {
        title: "Status",
        key: "status",
        dataIndex: "status",
        render: (_, { status, id }) => {
          const color = {
            Pending: "volcano",
            Active: "Green",
            Deactivated: "red",
          }[status];
          return (
            <>
              <Tag color={color} key={`key_driver_${id}`}>
                {status.toUpperCase()}
              </Tag>
            </>
          );
        },
      },
      {
        title: "Action",
        key: "action",
        // render: (_, record) => (
        //   <Space size="middle">
        //     <a>Invite {record.name}</a>
        //     <a>Delete</a>
        //   </Space>
        // ),
      },
    ],
    []
  );
  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Drivers"
              extra={
                <>
                  <Button
                    type="primary"
                    onClick={() => history.push("/drivers-add")}
                  >
                    Add
                  </Button>
                </>
              }
            >
              <Table columns={columns} dataSource={data?.data ?? []} />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Tables;
